/* ============================================================
   Email capture — writes to the consent source of truth (leads) and queues the
   transactional "your calculation" email. Both go through security-definer RPCs
   (capture_lead / queue_calc_email) so the client can't spoof confirmed state.
   Attribution (UTMs + visit) is pulled from the same session store signups use.
   ============================================================ */
import { supabase, isConfigured } from './supabase.js'
import { getUtms, getVisit, deviceType } from './utm.js'

// Store/﻿update the contact + consent. `marketing` is the promo-opt-in checkbox.
export async function captureEmail({ email, marketing = false, source = 'calc', consentText = null }) {
  if (!isConfigured) return { error: 'Backend not connected.' }
  const utms = getUtms()
  const visit = { ...getVisit(), device: deviceType() }
  const { data, error } = await supabase.rpc('capture_lead', {
    p_email: email,
    p_marketing: !!marketing,
    p_source: source,
    p_consent: consentText,
    p_utm: utms,
    p_visit: visit,
  })
  if (error) return { error: error.message }
  return { ok: true, ...(data || {}) } // { needs_confirm, confirm_token, unsub_token }
}

// Queue the "email me this calculation" transactional send (cron delivers it).
export async function queueCalcEmail(email, payload) {
  if (!isConfigured) return { error: 'Backend not connected.' }
  const { error } = await supabase.rpc('queue_calc_email', { p_email: email, p_payload: payload || {} })
  if (error) return { error: error.message }
  return { ok: true }
}
